import { Box } from "@mui/material";
import React from "react";
import { capitalize } from "lodash";
import { STATUS_BACKGROUND_COLOR, STATUS_COLOR } from "utils/constants";

function RenderStatus({ value, style }) {
  return (
    <Box
      align="left"
      sx={{
        backgroundColor: STATUS_BACKGROUND_COLOR[value],
        color: STATUS_COLOR[value],
        padding: 1,
        width: "85px",
        textAlign: "center",
        fontWeight: "500",
        borderRadius: "10px",
        ...style,
      }}
    >
      {capitalize(value.replace(/-/, " "))}
    </Box>
  );
}

export default RenderStatus;
